import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import './Faq.css'

const useStyles = makeStyles((theme) => ({
    root: {
        // width: '100%',
        // margin: '200px'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
}));

export default function Faq() {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <div className={[classes.root, 'faqMain'].join(' ')}>
            <h1>Your common questions, answered.</h1>
            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Typography className={classes.heading}>What is video conferencing?</Typography>
                    {/*<Typography className={classes.secondaryHeading}>I am an accordion</Typography>*/}
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        Video conferencing lets you instantly meet with anyone, without the need to travel.
                        Best of all, you can sign up free. Participants connect in a virtual meeting using HD video
                        and audio across web, desktop, mobile or video system.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                >
                    <Typography className={classes.heading}>How do I join a video conference?</Typography>
                    {/*<Typography className={classes.secondaryHeading}>*/}
                    {/*    You are currently not an owner*/}
                    {/*</Typography>*/}
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        Joining a video conference should be easy. With Summit, you get one button to push with the big green button and you’re in. You can join through desktop, mobile or web applications. And you can choose how you want to connect your audio, either through VoIP (computer audio), dial-in or having the meeting call your phone of choice.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                >
                    <Typography className={classes.heading}>Why do we need video conferencing?</Typography>
                    {/*<Typography className={classes.secondaryHeading}>*/}
                    {/*    Filtering has been entirely disabled for whole web server*/}
                    {/*</Typography>*/}
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        Video conferencing is a must-have for mobile and remote workers, because it gives them a high-quality way to interact with each other and stay in touch from any location or device. The benefits of real-time video conferences are extensive, ranging from more productive meetings to less time-consuming and expensive travel for in-person meetings.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className={classes.heading}>What are the common uses for video conferencing?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        Video conferencing is most commonly used for keeping virtual and remote teams connected through lifelike meetings. An online meeting is the perfect forum for an internal discussion, a team meeting, a client-facing presentation, a sales demo, and much more.
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}
